import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    background: var(--sl-color-neutral-0);
    min-height: 100%;
  }

  .content {
    padding: 1rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.5rem 0 1.5rem;
  }

  .page-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--sl-color-neutral-900);
  }

  .placeholder {
    text-align: center;
    color: var(--sl-color-neutral-600);
  }

  .placeholder p {
    margin: 0.75rem 0 0 0;
    font-size: 1.05rem;
  }
  .placeholder-icon { font-size: 1.5rem; color: var(--sl-color-neutral-400); }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
  }

  .template-list {
    margin-top: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .template-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    border: 1px solid var(--sl-color-neutral-200);
    border-radius: 8px;
    padding: 0.75rem;
  }

  .template-info { min-width: 0; }
  .template-name { font-weight: 600; color: var(--sl-color-neutral-900); }
  .template-desc { color: var(--sl-color-neutral-600); font-size: 0.9rem; overflow: hidden; text-overflow: ellipsis; }

  .centered { text-align: center; color: var(--sl-color-neutral-600); padding: 1rem; }

  .error {
    background: var(--sl-color-danger-50);
    border: 1px solid var(--sl-color-danger-200);
    color: var(--sl-color-danger-700);
    border-radius: 8px;
    padding: 0.75rem;
    margin-top: 0.75rem;
  }

  /* Simple adjustments for builder content inside dialog */
  sl-dialog::part(panel) {
    max-width: 900px;
    width: 90vw;
  }

  .builder {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: 65vh;
    overflow: auto;
    padding-right: 0.25rem;
  }

  .sections { display: flex; flex-direction: column; gap: 1rem; }
  .section-header, .question-header { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; margin-bottom: 0.5rem; }
  .questions { display: flex; flex-direction: column; gap: 0.75rem; margin-top: 0.75rem; }
  .section-body { background: var(--sl-color-neutral-50); padding: 0.75rem 1rem; border-radius: 8px; box-shadow: var(--sl-shadow-x-small); }
  .question-card { padding: 0.5rem 0; }
  .question-header { font-size: 0.85rem; color: var(--sl-color-neutral-700); text-transform: uppercase; letter-spacing: 0.03em; }
  .question-grid { display: grid; grid-template-columns: 1fr 180px 120px; gap: 0.75rem; align-items: end; margin-top: 0.25rem; }
  .section-body sl-input, .section-body sl-select, .section-body sl-switch { margin-top: 0.25rem; }
  sl-divider { margin: 0.5rem 0; }
  sl-details::part(summary) { font-weight: 600; font-size: 0.95rem; color: var(--sl-color-neutral-800); }
  .dialog-footer { display: flex; justify-content: flex-end; gap: 0.5rem; }

  @media (max-width: 768px) {
    .content {
      padding: 0.75rem 1rem;
    }
    .page-header {
      padding: 0.75rem 1rem 0 1rem;
    }
  }
`;
